import React, { useEffect } from "react";
import styles from "../../styles/layout/editor-dashboard-sidebar.module.scss";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";
import DashboardIcon from "../../public/assets/icons/DashboardIcon";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PendingPublicationIcon from "../../public/assets/icons/PendingPublicationIcon";
import PublishedVideoIcon from "../../public/assets/icons/PublishedVideoIcon";
import NotificationIcon from "../../public/assets/icons/NotificationIcon";
import MessageIcon from "../../public/assets/icons/MessageIcon";
import MyAccountIcon from "../../public/assets/icons/MyAccountIcon";
import ExpandArrowIcon from "../../public/assets/icons/ExpandArrowIcon";
import LogoutIcon from "../../public/assets/icons/LogoutIcon";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import messageIcon from "../../public/assets/images/messageIcon.svg";
import supportIcon from "../../public/assets/images/supportIcon.svg";
import SubmenuMessageIcon from "../../public/assets/icons/SubmenuMessageIcon";
import SubmenuSupportIcon from "../../public/assets/icons/SubmenuSupportIcon";
import { useDispatch } from "react-redux";
import { logout } from "../../redux-toolkit/slices/userSlice";
import EditorPendingPublicationIcon from "../../public/assets/icons/EditorPendingPublicationIcon";

const MenuItem = [
  {
    path: "/editor-dashboard",
    name: "Dashboard",
    icon: (isactive) => <DashboardIcon active={isactive} />,
    class: "Dashboard",
  },
  // {
  //   name: 'My Videos',
  //   icon:(isactive)=> <VideoMenuIcon active={isactive}/>,
  //   subitems: [
  //     {
  //       path: "/member-partner-dashboard/my-videos-approved#pending",
  //       name: "Pending",
  //       icon: (isactive) => <PendingPublicationIcon />,
  //     },
  //     {
  //       path: "/member-partner-dashboard/my-videos-approved#approved",
  //       name: "Approved",
  //       icon: (isactive) => <ApproveIcon />,
  //     },
  //     {
  //       path: "/member-partner-dashboard/my-videos-approved#rejected",
  //       name: "Rejected",
  //       icon: (isactive) => <RejectIcon />,
  //     },
  //     {
  //       path: "/member-partner-dashboard/my-videos-approved#duplicate",
  //       name: "Duplicate",
  //       icon: (isactive) => <DuplicateIcon />,
  //     },
  //   ],
  // },
  {
    path: "/editor-dashboard/editor-pending-publication",
    name: "Pending Publication",
    icon: (isactive) => <EditorPendingPublicationIcon active={isactive} />,
    class: "PendingPublication",
  },
  {
    path: "/editor-dashboard/editor-publish-video",
    name: "Published Videos",
    icon: (isactive) => <PublishedVideoIcon active={isactive} />,
    class: "PublishedVideos",
  },
  {
    path: "/editor-dashboard/notification",
    name: "Notifications",
    icon: (isactive) => <NotificationIcon active={isactive} />,
    class: "Notifications",
  },
  {
    name: "My Messages",
    icon: (isactive) => <MessageIcon active={isactive} />,
    class: "MyMessages",
    subitems: [
      {
        path: "/editor-dashboard/editor-message/messages",
        name: "Messages",
        icon: (isactive) => <SubmenuMessageIcon />,
      },
      {
        path: "/editor-dashboard/editor-support",
        name: "Support",
        icon: (isactive) => <SubmenuSupportIcon />,
      },
    ],
  },
  {
    path: "/editor-dashboard/editor-account",
    name: "My Account",
    icon: (isactive) => <MyAccountIcon active={isactive} />,
    class: "MyAccount",
  },
];

export const EditorDashboardSidebar = () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const router = useLocation();
  const routePush = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    MenuItem.map((menu, index) => {
      let hasSubitems = menu.subitems && menu.subitems.length > 0;

      if (hasSubitems) {
        menu.subitems.map((item) => {
          if (item.path + router.hash === router.pathname + router.hash) {
            console.warn(item.path + router.hash, "-----Path");
            console.warn(router.hash);
            console.warn(
              item.path + router.hash === router.pathname + router.hash
            );
            setExpanded(menu.name);
          }
        });
      }
    });
  }, []);
  const logoutFunc = () => {
    dispatch(logout());
    // toastSuccess("Logout Successful");
  };
  return (
    <Box className={styles.editorDashboardSidebar}>
      <Box className={styles.sideBar}>
        <PerfectScrollbar>
          <Box className={styles.menuList}>
            <List>
              {MenuItem.map((menu, index) => {
                let hasSubItems = menu.subitems && menu.subitems.length > 0;
                function checkSubItemActive() {
                  let active = false;
                  if (hasSubItems) {
                    menu.subitems.map((item) => {
                      if (item.path === router.pathname + router.hash) {
                        console.warn(item.path + router.hash, "-----Path");
                        active = true;
                      }
                    });
                    return active;
                  }
                }
                const isSubItemActive = checkSubItemActive();
                console.warn(isSubItemActive, "active????");
                return hasSubItems ? (
                  <ListItem
                    className={`${isSubItemActive && styles.menuActive
                      } sidebar-${menu.class.split(" ")[0]}`}
                  >
                    <Box className={styles.menuItem}>
                      <Box className={styles.menuIcon}>
                        {menu.icon(isSubItemActive)}
                      </Box>
                    </Box>
                    <Accordion
                      expanded={expanded === menu.name}
                      onChange={handleChange(menu.name)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`${menu.name}bh-content`}
                        id={`${menu.name}bh-header`}
                      >
                        {menu.name}
                      </AccordionSummary>
                      <AccordionDetails>
                        <List disablePadding className={styles.submenuList}>
                          {menu.subitems.map((submenu, index) => (
                            <ListItem
                              key={index}
                              className={
                                submenu.path ===
                                router.pathname + router.hash &&
                                styles.submenu_active
                              }
                            >
                              <Link to={submenu.path}>
                                {submenu.icon()}
                                <Typography variant="caption">
                                  {submenu.name}
                                </Typography>
                              </Link>
                            </ListItem>
                          ))}
                        </List>
                      </AccordionDetails>
                    </Accordion>
                  </ListItem>
                ) : (
                  <ListItem
                    className={`${menu.path === router.pathname && styles.menuActive
                      } sidebar-${menu.class.split(" ")[0]}`}
                    key={index}
                  >
                    <Box className={styles.menuItem}>
                      <Link to={menu.path}>
                        <Box className={styles.menuIcon}>
                          {menu.icon(menu.path === router.pathname)}
                        </Box>
                        <Typography variant="body1">{menu.name}</Typography>
                      </Link>
                    </Box>
                  </ListItem>
                );
              })}

              <ListItem className={styles.logoutIcon} onClick={logoutFunc}>
                <Box className={styles.menuItem}>
                  <Link to="">
                    <Box className={styles.menuIcon}>
                      <LogoutIcon />
                    </Box>
                    <Typography variant="body1">Logout</Typography>
                  </Link>
                </Box>
              </ListItem>
            </List>
          </Box>
        </PerfectScrollbar>
      </Box>
    </Box>
  );
};
